export default [
    // {
    //     name: 'trips',
    //     label: 'Trips',
    //     route: 'home',
    //     icon: 'fa-book'
    // },
    {
        name: 'notifications',
        route: 'notifications',
        icon: 'fa-bell-o',
        label: function () {
            let count = _.get(this.notifications, 'content.data.length')
            if(count > 0){
                return `<div class="center list-item__center list-item--longdivider__center">Notifications <span class="badge">${count}</span></div>`;
            }
            return `<div class="center list-item__center list-item--longdivider__center">Notifications</div>`;

        },
    },
    {
        name: 'profile',
        label: 'Profile',
        route: 'profile',
        icon: 'fa-commenting'
    },
    {
        name: 'change-password',
        label: 'Change Password',
        route: 'change-password',
        icon: 'fa-commenting'
    },
    {
        name: 'logout',
        label: 'Logout',
        icon: 'fa-graduation-cap',
        action: function () {
            this.$emit('logout')
            this.login.setContent({})
            this.customer.setContent({})
            document.body.classList.remove('theme-gold')
            document.body.classList.remove('theme-jade')
        },
    }
]



// WEBPACK FOOTER //
// ./src/config/menu.js